<template>
  <v-container fluid fill-height justify-center id="scrolling-techniques-7" class="overflow-y-auto px-6" key="servererror">
    <v-row class="max-w">
      <v-col class="text-center">
        <v-icon large>mdi-wifi-off</v-icon>
        <div class="display-1 font-weight-medium my-3">
          {{ $t('Error') }}
        </div>
        <div class="font-weight-light mb-8 c-lighter-1">
          {{ $t('666') }}
        </div>
        <v-btn x-large class="w-100 btn-secondary" to="/controllers">{{ $t('Sprobuj ponownie') }}</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {

}
</script>

<style>

</style>